"use client";

import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { getRandomHexColor } from "@/helpers/utils.helper";

type Props = {
  crrColor: string;
  className: string;
  textColor: string;
};

const ColorBlock = ({ crrColor, ...props }: Props) => {
  const [currColor, setCurrColor] = useState("");
  const [isCopying, setIsCopying] = useState(false);

  useEffect(()=>{
    setCurrColor(crrColor);
    setIsCopying(false)
  },[])

  const changeColorBlock = () => {
    setCurrColor(getRandomHexColor());
  };

  const copyToClipboard = async (blockColor: string) => {
    if (isCopying) return; // ignore extra clicks
    setIsCopying(true);
    try {
      await navigator.clipboard.writeText(blockColor);
      setCurrColor("Copied!");
      setTimeout(() => {
        setCurrColor(blockColor);
        setIsCopying(false); // allow next copy
      }, 500);
    } catch (err) {
      console.error("Failed to copy text: ", err);
      setIsCopying(false); // reset on error too
    }
  };

  return (
    <div
      data-testid="ColorBlock"
      style={{
        backgroundColor: currColor,
      }}
      className={classNames(
        "min-h-[100px] flex items-center justify-center",
        props?.className
      )}
      onClick={() => {
        changeColorBlock();
      }}
    >
      <span
        aria-disabled
        className="cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          copyToClipboard(currColor);
        }}
        style={{ color: props?.textColor }}
      >
        {currColor}
      </span>
    </div>
  );
};

export default ColorBlock;